import React from "react";
import {Col, Row, Typography} from "antd";

import './DashedValueRow.css'

import {toLocaleMoney} from "../../services/NumberService"

export default function DashedValueRow({ title, value, valueRender = null, valueSpan = 4, type }) {

  let display = value
  if (typeof display == "number") display = valueRender ? valueRender(toLocaleMoney(value)) : toLocaleMoney(value)

  return (
    <Row type="flex" justify="space-between" align="bottom">
      <Col sm={24 - valueSpan} xs={22 - valueSpan}>
        <Row type="flex" gutter={30}>
          <Col>
            <span>{title}</span>
          </Col>
          <Col className="dashed-space" />
        </Row>
      </Col>
      <Col align="right" sm={valueSpan} xs={valueSpan + 2}>
        <Typography.Text type={ value < 0 ? "danger" : type === 'negative' ? "danger" : ""} strong={true}>
          {type === 'negative' ? `- ${display}`: display}
        </Typography.Text>
      </Col>
    </Row>
  )
}
